// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3v5v2","buttons":"styles_buttons__2B4rB"};